const ExternalLink = ({ ...props }) => (
  <a rel="noreferrer" target="_blank" {...props} />
)

export default ExternalLink
